/*
Modals are handled differently on desktop and mobile; on desktop they're
Reactstrap Modals, and on mobile they temporarily replace all content on the
page (because scrolling in modals isn't handled well, and because the modal
margin is a waste of space on space-constrained devices like smartphones)
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from './store';
import Panic from './Panic';
import {
	Modal as ReactstrapModal,
	ModalBody as ReactstrapModalBody,
} from 'reactstrap';
import { OnlyIfVisible } from './Visibility';
import { classes } from './CUtil';

function ModalOpen(name, data) {
	store.push_modal(name, data);
}

function ModalUpdate(name, data, data_keep_set) {
	store.update_modal(name, data, data_keep_set);
}

function ModalClose() {
	store.pop_modal();
}

class Modal extends Component {
	allow_close_via_ui() {
		return true;
	}

	do_toggle() {
		if (this.allow_close_via_ui()) ModalClose();
	}

	render() {
		var full = null;
		if (this.props.is_open) {
			const outer_class = classes("ad_modal_fullscreen", this.get_fullscreen_bg_class());
			const header = this.allow_close_via_ui() ? (
				<div className="ad_modal_fullscreen_header d-flex">
					<div
						role="button"
						tabIndex={0}
						onClick={ModalClose}
						onKeyPress={ModalClose}
						className="ml-auto ad_modal_fullscreen_close"
					/>
				</div>
			) : null;
			full = (
				<div className="d-md-none d-block">
					<div className={outer_class}>
						{this.do_render_mobile_header() && header}
						<OnlyIfVisible>{this.mrender(true)}</OnlyIfVisible>
					</div>
				</div>
			);
		}

		const cpatch = (c, type="block") => c + " d-none d-md-" + type;
		return (
			<div>
				<ReactstrapModal
					centered={true}
					isOpen={this.props.is_open}
					toggle={this.do_toggle.bind(this)}
					className={cpatch(this.get_bootstrap_modal_class(), "flex")}
					backdropClassName={cpatch("ad_modal_backdrop")}
					contentClassName={cpatch("ad_modal_content")}
					wrapClassName={cpatch("")}
				>
					<ReactstrapModalBody className="p-0 ad_modal_bootstrap">
						<div className="d-none d-md-block">
							<OnlyIfVisible>{this.mrender(false)}</OnlyIfVisible>
						</div>
					</ReactstrapModalBody>
				</ReactstrapModal>
				{full}
			</div>
		);
	}

	do_render_mobile_header() {
		return true;
	}

	// render function for the modal contents; you must override this in a subclass
	mrender() { throw new Error("you must override this function"); }

	// return the name you use for ModalOpen etc
	get_name() { throw new Error("you must override this function"); }

	// class to use for space around fullscreen modal
	get_fullscreen_bg_class() { return ""; }

	// class to use for Reactstrap's <Modal className="...">
	get_bootstrap_modal_class() { return ""; }
}

function ModalContainerContent(props) {
	return props.children || null;
}

var ModalContainer = (props) => {
	const current_modal = props.modal_stack.length === 0 ? null : props.modal_stack[props.modal_stack.length-1];
	var content = null;

	return React.Children.map(props.children, child => {
		if (child.type === ModalContainerContent) {
			if (content !== null) Panic("more than one <ModalContainerContent/> found");
			var classes = "d-flex flex-column page-template";
			if (current_modal !== null) classes = "d-none d-md-block";
			return <div className={classes}>{child}</div>
		} else if (child.type.prototype instanceof Modal) {
			const modal_is_open = current_modal !== null && current_modal.name === child.type.prototype.get_name();
			const pass_props = current_modal ? current_modal.data : {};
			return React.cloneElement(child, {is_open: modal_is_open, ...pass_props});
		} else {
			Panic("expected <ModalContainerContent/> or <Modal> subclass");
		}
	});
}

ModalContainer = connect(
	(state) => ({modal_stack: state.modal_stack})
)(ModalContainer);

export {
	ModalOpen,
	ModalClose,
	ModalUpdate,
	Modal,
	ModalContainer,
	ModalContainerContent,
};



// WEBPACK FOOTER //
// ./src/Modal.js